import { useMemo } from "react";
import {
  getDefaultShiftsSortedBySequence,
  normalizeScheduleCellCode,
} from "@/utils/shift-util";
import { FIXED_SHIFTS } from "./useSortShift";

export interface NurseWithSchedule {
  schedule?: (string | { code: string })[] | null;
}

type ShiftWithDefault = {
  shift_id: string;
  default_shift?: string | null;
  sequence?: number;
};

/**
 * @param nurses - schedule이 있는 간호사 목록
 * @param availableShifts - 시프트 목록 (있으면 default_shift 기준 동적 메인 시프트 사용)
 */
export function useVisibleShifts(
  nurses: NurseWithSchedule[],
  availableShifts?: ShiftWithDefault[]
) {
  return useMemo(() => {
    const mainShiftIds = availableShifts?.length
      ? getDefaultShiftsSortedBySequence(availableShifts).map((s) => s.shift_id)
      : [...FIXED_SHIFTS];

    if (!nurses || nurses.length === 0) return mainShiftIds;

    const allShiftCounts: Record<string, number> = {};

    nurses.forEach((nurse) => {
      nurse.schedule?.forEach((shift) => {
        const trimmed = normalizeScheduleCellCode(shift).trim();
        if (trimmed && trimmed !== "-") {
          allShiftCounts[trimmed] = (allShiftCounts[trimmed] ?? 0) + 1;
        }
      });
    });

    const mainIdsSet = new Set(mainShiftIds);
    const dynamicShifts = Object.keys(allShiftCounts).filter(
      (shiftId) => !mainIdsSet.has(shiftId)
    );

    return [...mainShiftIds, ...dynamicShifts];
  }, [nurses, availableShifts]);
}
